module.exports = __webpack_public_path__ + "static/media/10H.d0a839fe.jpg";